import React from "react";

function TransitionBanner({ orientation = "up" }) {
  const name = orientation === "up" ? "top" : "bottom";

  return <div className={"transition-banner-" + name}></div>;
}

export default TransitionBanner;
